import React from 'react';
import { Link } from 'react-router-dom';

import LogoWhite from '../../assets/LogoWhite.png';
import Agoprev from '../../assets/Agoprev.png';
import Jornada from '../../assets/Jornada.png';

import { Container, Menu } from './Footer_Styles';

export default function Header() {

  return (
    <Container>
      <br/>
      <Menu>
        <nav>
            <p>Realização</p>
            <div>
              <a href='https://jornadaeduc.com.br/' target='_blank' rel="noreferrer">
                <img
                  src={Jornada}
                  alt="Jornada Educacional" 
                />
              </a>
              <vr/>
              <a href='https://agoprev.org.br/' target='_blank' rel="noreferrer">
                <img
                  src={Agoprev}
                  alt="Agoprev"
                />
              </a>
            </div>
            <p>Dúvidas</p>
            <div>
              <p>(62) 98100-0025  |  contato@expoprev.com.br</p>
            </div>
        </nav>
        <aside>
            <Link to="/">
              <img
                src={LogoWhite} 
                alt="ExpoPrev"
              />
            </Link>
            <Link to="/apresentacao">Apresentação</Link>
            <Link to="/local">Local</Link>
            <Link to="/programacao">Programação</Link>
            <Link to="/inscricao">Inscrição</Link>
        </aside>
      </Menu>
    </Container>
  );
}
